"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseLandingPoint = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var TailoredPages_1 = require("Onboarding/CensusCollector/ChooseLandingPoint/TailoredPages");
var Explorer_1 = require("Onboarding/CensusCollector/ChooseLandingPoint/Explorer");
var ChooseLandingPoint = function (props) {
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var dataStore = (0, inversify_react_1.useInjection)("censusCollectorStore");
    return (react_1.default.createElement("div", null, usingFeature(FeatureFlag_1.FeatureFlag.TailoredPages) && dataStore.shouldShowTailoredPages ? (react_1.default.createElement(TailoredPages_1.TailoredPages, { onComplete: props.onComplete })) : (react_1.default.createElement(Explorer_1.Explorer, { onComplete: props.onComplete }))));
};
exports.ChooseLandingPoint = ChooseLandingPoint;
